
export class POC{
  nome:string;
  codigo:number;
  cpf:string;
}
